export { default } from './EzFilterList.vue';
